import { Container, AppBar, Toolbar, Box, Modal, Button, TextField, Typography, Paper } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Navigate, useNavigate } from "react-router-dom";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function EditReligion() {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  let navigate = useNavigate();
  const [religionName, setReligionName] = useState("");
  const { religionID } = useParams();
  const [loadingBarProgress, setLoadingBarProgress] = useState('');

  useEffect(() => {
    fetchReligionData();
  }, []);

  const fetchReligionData = async () => {
    try {
      const token = sessionStorage.getItem('token');
      const apiUrl = process.env.REACT_APP_BASE_URL;
      setLoadingBarProgress(30);
      const response = await fetch(`${apiUrl}/Religion/GetReligion`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({}),
      });

      if (response.ok) {
        const religionData = await response.json();
        const foundReligion = religionData.find(item => item.religionID === parseInt(religionID));
        if (foundReligion) {
          setReligionName(foundReligion.religionName);
        } else {
          console.error('Religion not found');
        }
      } else {
        console.error('Error fetching religion data');
      }
      setLoadingBarProgress(100);
    } catch (error) {
      console.error('API request error:', error);
    }
  };


  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalType, setModalType] = useState('success');

  const handleUpdate = async () => {
    const apiUrl = process.env.REACT_APP_BASE_URL;
    const token = sessionStorage.getItem('token');
    setLoadingBarProgress(30);
    try {
      const response = await fetch(`${apiUrl}/Religion/Id?Id=${religionID}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({ religionName }),
      });

      const data = await response.json();
      setLoadingBarProgress(100);

      const message = (data && (data.msg || data.message)) || 'Religion updated successfully.';
      const status = (data && data.status && data.status.toString().toLowerCase()) || '';
      const lowerMsg = (message || '').toString().toLowerCase();
      const errorKeywords = ['already exist', 'already exists', 'failed', 'error', 'unable', 'cannot'];
      const messageHasError = status.includes('failed') || errorKeywords.some(k => lowerMsg.includes(k));

      setModalType(messageHasError ? 'error' : 'success');
      setModalMessage(message);
      setModalOpen(true);

    } catch (error) {
      setLoadingBarProgress(0);
      setSnackbarMessage('Error updating religion');
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
    }
  };

  return (
    <Container>

      <AppBar position="static" style={{ backgroundColor: "#0B1F3D" }}>
        <Toolbar>
          <Typography variant="h4" component="div" style={{ fontWeight: 'bold' }}>
            Edit Religion
          </Typography>
        </Toolbar>
      </AppBar>
      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6 }}>

        <div
          className="row g-3 align-items-center"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: '100%',
            marginTop: 6
          }}
        >
          <div className="col-md-8" style={{ width: '100%', }}>
            <TextField
              fullWidth
              label="Religion Name"
              id="religionName"
              sx={{ marginBottom: 3 }}
              value={religionName}
              required
              onChange={(e) => setReligionName(e.target.value)}
            />
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
          <Button
            variant="contained"
            color="primary"
            sx={{ mx: 1 }}
            disabled={!religionName} onClick={handleUpdate}>
            <b>UPDATE</b>
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => { navigate(-1) }}>
            <b>CANCEL</b>
          </Button>
        </div>
      </Paper>

      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        aria-labelledby="response-modal-title"
        aria-describedby="response-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: modalType === 'error' ? '#8B0000' : '#0B1F40', padding: '12px 16px' }}>
            <Typography id="response-modal-title" variant="h6" sx={{ color: '#fff' }}>
              {modalType === 'error' ? 'Error ❌' : 'Religion Updated ✅'}
            </Typography>
          </Box>

          <Box sx={{ padding: '20px' }}>
            <Typography id="response-modal-description" sx={{ mb: 2 }}>
              {modalMessage || (modalType === 'error' ? 'An error occurred.' : 'Religion updated successfully.')}
            </Typography>

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setModalOpen(false);
                  if (modalType !== 'error') navigate(-1);
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
<Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>
    </Container>
  );
}

export default EditReligion;
